import { request } from '@/common';
import { HelperCore } from '@/common/dependencies';
import { makeAutoObservable, runInAction } from 'mobx';
import createDebug from '@/common/create-debug';

const debugText = createDebug('text');
const debugRead = createDebug('read');
const debugTranslate = createDebug('translate');

// 断句
// const REG_SEP = /(\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\.{1,6}|\?|\!|\,|\;|[^\s]+\s)\s*/;
const REG_SEP = /(\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\.{1,6}|\?|\!|\,|\;)/;

// 语音转换，文本长度限制
const minTTSTextLength = 15;
// 消息间间隔
const timeMsgSep = 500;

const filterText = text => {
  try {
    text = text.replace(/[#|\*|\n]/gm, '');

    text = text
      .replace(/360/g, '三六零')
      .replace(/3721/g, '三七二幺')
      .replace(/isc/gi, 'ISC');

    text = text
      .trim()
      .replace(/\n/gm, '')
      .replace(
        // eslint-ignore-next-line
        /(ht|f)tp(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&%$#_]*)?/gim,
        ''
      )
      .replace(/\[\[\d+\].*?\]的/gm, '搜索的')
      .replace(/\[\[\d+\].*?\]/gm, '');
  } catch (e) {}
  return text;
};

class ReadStore {
  list = [
    // {
    //   id : `${index}_${ttsId}`,
    //   index : 0,
    //   ttsId : "",
    //   type : "a",
    //   text : "",
    //   typing : false,
    // },
  ]
  ttsList = [
    // {
    //   id : `${index}_${ttsId}`,
    //   index : 0,
    //   ttsId : "",
    //   type : "a",
    //   text : "",
    //   buffer : null,
    // },
  ];

  isReading = false;
  audioContext = null;
  ttsIndex = 0;         // tts list 编号
  hasStopped = false;
  waitIndex = 0;
  currentTTSMsgIndex = null;  // 正在朗读的消息序号
  hasSendFirstTrans = false;
  hasTrasFirst = false;
  isTransing = 0;

  options = {
    /**
     * 消息切换
     * @param {Mixed} index setIndex 传入的 index，可以是任意 ID
     * @deprecated  不再缓存播放数据，不再考虑多条消息
     */
    onIndexChange : (index) => {

    },
    /**
     * 当前播放的文案，可用于显示字幕
     * @param {String} text 
     */
    onTextChange : (text) => {

    },
    /**
     * 播放完毕
     * 回传 index 时，为播放完毕
     * 被手动停止时，回传 undefined
     * @param {?Mixed} index setIndex 传入的 index
     */
    onEnd : (index) => {

    },
  }

  constructor (options = {}) {
    this.options = {
      ...this.options,
      ...options,
    }

    makeAutoObservable(this);
  }

  getID (index, ttsId) {
    return `${index}_${ttsId}`;
  }

  initAudioContext () {
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    this.audioContext = new AudioContext();
  }

  /**
   * 流式输入，更新内容
   */
  appendText (index, ttsId, type, text, typing = true) {
    if(index != this.currentTTSMsgIndex){
      return;
    }

    // debug
    // HelperCore.log(`chatStore appendText`, index, ttsId, type, text, typing);

    const id = this.getID(index, ttsId);
    const item = this.list.find(item => item.id == id);
    if(item){
      item.text += text;
    }
    else {
      this.list.push({
        id,
        index,
        ttsId,
        type,
        text,
        typing,
      });
    }

    if((!this.hasSendFirstTrans || !this.isReading) && !this.hasStopped){
      this.translateNext();
    }
  }
  /**
   * 角色输入完毕
   */
  stopTyping (index, ttsId) {
    // debug
    // HelperCore.log(`chatStore stopTyping`, index);

    const id = this.getID(index, ttsId);
    const item = this.list.find(item => item.id == id);
    if(item){
      item.typing = false;
      this.translateNext();
    }
  }
  /**
   * 转化 tts
   */
  translateNext = async () => {
    const firstItem = this.list[0];
    if(!firstItem){
      return;
    }
    if(firstItem.text.length <= minTTSTextLength){
      // 输入中，长度不足，等待
      if(firstItem.typing){
        debugText(`文案不足 ---- ${firstItem.text} ${firstItem.text.length}`);
        return;
      }
      // 发言结束
      this.list.splice(0, 1);
      // 已转化完成
      if(!firstItem.text.trim()){
        return;
      }
      await this.textToAudioStream(firstItem.ttsId, firstItem.text, firstItem);
      return;
    }

    let ttsText = "";
    let text = firstItem.text;
    while(ttsText.length < minTTSTextLength && text){
      const result = text.match(REG_SEP);
      if(result){
        const index = result.index;
        const len = result[0]?.length || 1;
        if(index >= 0){
          ttsText += (text.slice(0, index + len));
          text = text.slice(index + len);
        }
      }
      else {
        ttsText += text;
        text = '';
      }
    }
    firstItem.text = firstItem.text.slice(ttsText.length);
    await this.textToAudioStream(firstItem.ttsId, ttsText, firstItem);
    this.translateNext();
  }

  /**
   * 朗读
   */
  readNext = async () => {
    if(this.isReading){
      return;
    }
    if(this.hasStopped){
      return;
    }
    if(!this.ttsList.length){
      return;
    }
    if(!this.audioContext){
      // 第一个请求的尚未返回
      if(this.ttsList[0].ttsIndex != this.waitIndex){
        return;
      }
      this.initAudioContext();
    }
    const ttsItem = this.ttsList.shift();
    this.options.onIndexChange(ttsItem.index);
    runInAction(() => {
      this.isReading = true;
      this.currentTTSMsgIndex = ttsItem.index;
    });
    try{
      const audioBuffer = await this.audioContext.decodeAudioData(ttsItem.buffer);
      const source = this.audioContext.createBufferSource();
      source.connect(this.audioContext.destination);
      source.buffer = audioBuffer;
      source.addEventListener('ended', () => {
        debugRead(`结束朗读 ---- ${ttsItem.text}`);
        this.onPlayEnd();
      });
      if(ttsItem.index != this.currentTTSMsgIndex){
        return;
      }
      this.options.onTextChange(ttsItem.text);
      debugRead(`开始朗读 ---- ${ttsItem.text}`);
      source.start();
    } catch(e){
      debugRead(`朗读报错 ---- ${ttsItem.text}`);
      this.onPlayEnd();
    }
  }

  onPlayEnd = () => {
    runInAction(() => {
      this.isReading = false;
      if(this.ttsList.length){
        this.readNext();
      }
      else if(this.isTransing){

      }
      else {
        this.options.onEnd(this.currentTTSMsgIndex);
      }
    });
  }

  /**
   * 转化 tts buffer
   */
  textToAudioStream = (id, text, textItem) => {
    // debug
    // HelperCore.log(`转换 tts`, id, text);

    if(textItem.index != this.currentTTSMsgIndex){
      return;
    }

    const beginTime = +new Date;
    textItem = HelperCore.copyObj(textItem);
    const ttsIndex = this.ttsIndex++;
    this.hasSendFirstTrans = true;
    this.isTransing++;

    const filteredText = filterText(text);
    debugTranslate(`开始转换 ---- ${filteredText}`);
    const uri = `/tts/v1?${HelperCore.param({ 
      roleid: id,
    })}`;
    return request.post(uri, {
      text: filteredText,
      audio_type : "mp3",
      format: 'stream',
      ttsIndex,
    },
    {
      timeout: 60 * 1000,
      responseType: 'arraybuffer',
    })
    .then(arrayBuffer => {
      runInAction(() => {
        if(arrayBuffer instanceof ArrayBuffer){
          // debug
          // HelperCore.log(`转化 ${filteredText} 耗时:`, `${((+new Date - beginTime) / 1000).toFixed(2)}s`);

          if(textItem.index == this.currentTTSMsgIndex){
            this.ttsList.push({
              ...textItem,
              text : filteredText,
              ttsIndex,
              buffer : arrayBuffer.slice(0),
            });
            this.ttsList.sort((a, b) => {
              return a.ttsIndex > b.ttsIndex ? 1 : -1;
            });
          }
        }
      });
    })
    .catch((res) => {})
    .finally(() => {
      debugTranslate(`完成转换 ---- ${filteredText}`);
      this.readNext();
      runInAction(() => {
        this.hasTrasFirst = true;
        this.isTransing--;
      });
    });
  }

  /**
   * 从某一条消息开始播放
   * @param {Number} index 
   */
  setIndex = (index, dialogs) => {
    // debug
    HelperCore.log(`chatStore setIndex`, index);

    this.audioContext?.close();
    this.isReading = false;
    this.audioContext = null;
    this.hasStopped = false;
    this.ttsIndex = 0;
    this.currentTTSMsgIndex = index;
    this.ttsList = [];
    this.list = [];
    this.hasSendFirstTrans = false;
    this.hasTrasFirst = false;

    /**
     * {
     *    role : {
     *      uid,          // 用于调用 tts 接口
     *      tag,          // 用于调用 tts 接口
     *    },
     *    type : "",      // 用于生成消息 ID
     *    content : "",   // 文本
     *    typing : true,  // 是否正在输出
     * }
     */
    const msgItem = Array.isArray(dialogs) ? dialogs[index] : dialogs;

    const { content, typing, role, type } = msgItem;
    const { tag, uid } = role;
    const ttsId = tag || uid;

    this.appendText(index, ttsId, type, content, !!typing);
  }

  /**
   * 终止朗读
   */
  stop = () => {
    this.hasStopped = true;
    this.currentTTSMsgIndex = null;
    this.audioContext && this.audioContext.suspend();
    this.options.onEnd();
  }
}

export default ReadStore;